import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Container, Button, Row, Col, Table, Form, Spinner } from 'react-bootstrap';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';

const MastersFragment = () => {
    const [designation, setDesignation] = useState('');
    const [editID, setEditID] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [categorys, setCategorys] = useState([]);
    const [categoryQuizs, setCategoryQuizs] = useState([]);
    const [categorySurveys, setCategorySurveys] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [roles, setRoles] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [selectedSchema, setSelectedSchema] = useState('');
    const mongooseSchemas = [
        { name: 'Category School', value: 'categoryCompany' },
        { name: 'Semester', value: 'department' },
        { name: 'Year', value: 'designation' },
        { name: 'Section', value: 'role' },
        { name: 'Category Quiz', value: 'categoryQuiz' },
        { name: 'Category Survey', value: 'categorySurvey' },
    ];

    useEffect(() => {
        fetchCategorys();
        fetchRoles();
        fetchDepartments();
        fetchDesignations();
        fetchCategoryQuizs();
        fetchCategorySurveys();
    }, []);

    const fetchCategorys = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            fetch("https://beiguru.co.in/categoryCompany", requestOptions)
                .then((response) => {
                    if (response.status == 401) {
                        localStorage.clear();
                        window.location.reload();
                        return [];
                    } else {
                        return response.json()
                    }
                }).then((result) => setCategorys(result))
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    const fetchRoles = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            fetch("https://beiguru.co.in/role", requestOptions)
                .then((response) => {
                    if (response.status == 401) {
                        localStorage.clear();
                        window.location.reload();
                        return [];
                    } else {
                        return response.json()
                    }
                }).then((result) => setRoles(result))
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    const fetchDepartments = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            fetch("https://beiguru.co.in/department", requestOptions)
                .then((response) => {
                    if (response.status == 401) {
                        localStorage.clear();
                        window.location.reload();
                        return [];
                    } else {
                        return response.json()
                    }
                }).then((result) => setDepartments(result))
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    const fetchDesignations = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            fetch("https://beiguru.co.in/designation", requestOptions)
                .then((response) => {
                    if (response.status == 401) {
                        localStorage.clear();
                        window.location.reload();
                        return [];
                    } else {
                        return response.json()
                    }
                }).then((result) => setDesignations(result))
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    const fetchCategoryQuizs = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            fetch("https://beiguru.co.in/categoryQuiz", requestOptions)
                .then((response) => {
                    if (response.status == 401) {
                        localStorage.clear();
                        window.location.reload();
                        return [];
                    } else {
                        return response.json()
                    }
                }).then((result) => setCategoryQuizs(result))
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    const fetchCategorySurveys = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            fetch("https://beiguru.co.in/categorySurvey", requestOptions)
                .then((response) => {
                    if (response.status == 401) {
                        localStorage.clear();
                        window.location.reload();
                        return [];
                    } else {
                        return response.json()
                    }
                }).then((result) => setCategorySurveys(result))
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await fetch(`https://beiguru.co.in/${selectedSchema}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('token') // Replace with your JWT token
                },
                body: JSON.stringify({ name: designation })
            });
            if (!response.ok) {
                throw new Error('Failed to create designation');
            }
            setDesignation('');
            fetchCategorys();
            fetchRoles();
            fetchDepartments();
            fetchDesignations();
            fetchCategoryQuizs();
            fetchCategorySurveys();
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleModify = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await fetch(`https://beiguru.co.in/${selectedSchema}/${editID}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('token') // Replace with your JWT token
                },
                body: JSON.stringify({ name: designation })
            });
            if (!response.ok) {
                throw new Error('Failed to create designation');
            }
            setDesignation('');
            fetchCategorys();
            fetchRoles();
            fetchDepartments();
            fetchDesignations();
            fetchCategoryQuizs();
            fetchCategorySurveys();
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleEdit = (selectedSchema, data) => {
        setDesignation(data.name);
        setEditID(data._id);
        setSelectedSchema(selectedSchema);
        setIsEdit(true);
    };

    const handleDelete = async (selectedSchema, deleteID) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this master data?");
        if (!isConfirmed) return;
        try {
            const response = await fetch(`https://beiguru.co.in/${selectedSchema}/${deleteID}`, {
                method: 'DELETE',
                headers: { 'Authorization': localStorage.getItem('token') },
            });
            if (response.ok) {
                alert('Master data deleted successfully');
                fetchCategorys();
                fetchRoles();
                fetchDepartments();
                fetchDesignations();
                fetchCategoryQuizs();
                fetchCategorySurveys();
            } else {
                alert('Failed to delete master data');
            }

        } catch (error) {
            console.error('Error deleting master:', error);
            alert('Failed to delete master data');
        }
    };

    return (
        <Grid item xs={10} style={{ padding: '20px', height: '100%', fontFamily: "Noto Sans", fontWeight: '500', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
            <Container fluid style={{ height: '100%', }}>
                <div style={{ justifyContent: 'space-between', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'row' }}><h4>Data Master</h4></div>
                <div>
                    <Form onSubmit={isEdit ? handleModify : handleSubmit} style={{ justifyContent: 'start', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'row' }}>
                        <Form.Group controlId="formCompany">
                            <Form.Control
                                className="w-100"
                                style={{ width: '100%', borderRadius: '20px' }}
                                as="select"
                                value={selectedSchema}
                                onChange={(e) => {
                                    setSelectedSchema(e.target.value);
                                }}>
                                <option value="">Select a master</option>
                                {mongooseSchemas.map(company => (
                                    <option key={company.value} value={company.value}>{company.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <div style={{ width: '10px' }} />
                        <Form.Group controlId="formCourseTitle">
                            <Form.Control
                                className="w-20"
                                style={{ borderRadius: '20px' }}
                                type="text"
                                placeholder="Enter Field Name"
                                value={designation}
                                onChange={(e) => setDesignation(e.target.value)}
                            />
                        </Form.Group>
                        <div style={{ width: '10px' }} />
                        <Button
                            style={{ fontWeight: '600', borderRadius: '20px' }}
                            elevation={3}
                            className="w-20"
                            variant="primary"
                            type="submit"
                            disabled={isLoading}>
                            {isLoading ? (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            ) : null}
                            {isEdit ? 'Edit' : 'Add'} Data
                        </Button>
                    </Form>
                </div>
                <div style={{ height: '10px' }} />
                <Row>
                    <Col xs={2}>
                        Category(School)
                        <div style={{ height: '10px' }} />
                        <div>
                            {/* Display added designations in a table */}
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {categorys.map((designation, index) => {
                                        console.log(designation.name);
                                        return <tr key={index}>
                                            <td>{designation.name}<p style={{ margin: '0px', padding: '0px', fontSize: '8px' }}>{designation._id}</p></td>
                                            <td>
                                                <EditNoteIcon onClick={() => handleEdit('categoryCompany', designation)} style={{ color: 'green', cursor: 'pointer' }} />
                                                <DeleteSweepIcon onClick={() => handleDelete('categoryCompany', designation._id)} style={{ color: 'red', cursor: 'pointer' }} />
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                    <Col xs={2}>
                        Semester
                        <div style={{ height: '10px' }} />
                        <div>
                            {/* Display added designations in a table */}
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {departments.map((designation, index) => {
                                        console.log(designation.name);
                                        return <tr key={index}>
                                            <td>{designation.name}<p style={{ margin: '0px', padding: '0px', fontSize: '8px' }}>{designation._id}</p></td>
                                            <td>
                                                <EditNoteIcon onClick={() => handleEdit('department', designation)} style={{ color: 'green', cursor: 'pointer' }} />
                                                <DeleteSweepIcon onClick={() => handleDelete('department', designation._id)} style={{ color: 'red', cursor: 'pointer' }} />
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                    <Col xs={2}>
                        <div>Year</div>
                        <div style={{ height: '10px' }} />
                        <div>
                            {/* Display added designations in a table */}
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {designations.map((designation, index) => {
                                        console.log(designation.name);
                                        return <tr key={index}>
                                            <td>{designation.name}<p style={{ margin: '0px', padding: '0px', fontSize: '8px' }}>{designation._id}</p></td>
                                            <td>
                                                <EditNoteIcon onClick={() => handleEdit('designation', designation)} style={{ color: 'green', cursor: 'pointer' }} />
                                                <DeleteSweepIcon onClick={() => handleDelete('designation', designation._id)} style={{ color: 'red', cursor: 'pointer' }} />
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                    <Col xs={2}>
                        Section
                        <div style={{ height: '10px' }} />
                        <div>
                            {/* Display added designations in a table */}
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {roles.map((designation, index) => {
                                        console.log(designation.name);
                                        return <tr key={index}>
                                            <td>{designation.name}<p style={{ margin: '0px', padding: '0px', fontSize: '8px' }}>{designation._id}</p></td>
                                            <td>
                                                <EditNoteIcon onClick={() => handleEdit('role', designation)} style={{ color: 'green', cursor: 'pointer' }} />
                                                <DeleteSweepIcon onClick={() => handleDelete('role', designation._id)} style={{ color: 'red', cursor: 'pointer' }} />
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                    <Col xs={2}>
                        Category(Quiz)
                        <div style={{ height: '10px' }} />
                        <div>
                            {/* Display added designations in a table */}
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {categoryQuizs.map((designation, index) => {
                                        console.log(designation.name);
                                        return <tr key={index}>
                                            <td>{designation.name}<p style={{ margin: '0px', padding: '0px', fontSize: '8px' }}>{designation._id}</p></td>
                                            <td>
                                                <EditNoteIcon onClick={() => handleEdit('categoryQuiz', designation)} style={{ color: 'green', cursor: 'pointer' }} />
                                                <DeleteSweepIcon onClick={() => handleDelete('categoryQuiz', designation._id)} style={{ color: 'red', cursor: 'pointer' }} />
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                    <Col xs={2}>
                        Category(Survey)
                        <div style={{ height: '10px' }} />
                        <div>
                            {/* Display added designations in a table */}
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {categorySurveys.map((designation, index) => {
                                        console.log(designation.name);
                                        return <tr key={index}>
                                            <td>{designation.name}<p style={{ margin: '0px', padding: '0px', fontSize: '8px' }}>{designation._id}</p></td>
                                            <td>
                                                <EditNoteIcon onClick={() => handleEdit('categorySurvey', designation)} style={{ color: 'green', cursor: 'pointer' }} />
                                                <DeleteSweepIcon onClick={() => handleDelete('categorySurvey', designation._id)} style={{ color: 'red', cursor: 'pointer' }} />
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Grid>);
}

export default MastersFragment;